// How long a critical alarm rings before nobody answering it makes it MISSED.
//
// Shared by the broker's sweep, which stamps `missedAt` on the stored alert, and the console, which
// moves the emergency card into the missed list at the same moment. One constant on both sides is
// what keeps the card and the stored record from disagreeing about when the ringing stopped.
//
// MISSED MOVES AN EMERGENCY, IT NEVER REMOVES ONE. A missed alert stays `open`: in the bell, the
// alert log and on the map, until an operator calls back or dismisses it. An SOS press is one frame,
// sent once, so a wearer who cannot press again must still be in front of someone.
//
// Browser-safe and dependency-free: the console imports this barrel.

/** How long a critical alarm rings. Two minutes: long enough to reach the console, short of a call. */
export const SOS_RING_WINDOW_MS = 2 * 60 * 1000

/**
 * When an alarm last heard from at `lastSeenAtMs` stops ringing, in epoch ms.
 *
 * Measured from the LAST sighting, not the first: a worker pressing SOS again inside the window keeps
 * the same alert ringing, exactly as a phone that is still ringing does not log a missed call.
 */
export function sosMissedAtMs(lastSeenAtMs: number): number {
  return lastSeenAtMs + SOS_RING_WINDOW_MS
}
